"use client";

import useFeatureFlag from "@/lib/feature-flags/hooks/useFeatureFlag";
import {
  SPANISH_EXPERIENCE_DEFAULT,
  SPANISH_EXPERIENCE_FLAG,
  isSpanishExperienceEnabled,
} from "./spanishExperience";

export function useSpanishExperienceEnabled() {
  const { flagValue, isLoading } = useFeatureFlag(
    SPANISH_EXPERIENCE_FLAG,
    SPANISH_EXPERIENCE_DEFAULT,
  );

  return {
    isLoading,
    flagValue,
    isEnabled: isSpanishExperienceEnabled(flagValue),
  };
}
